module.exports = __webpack_public_path__ + "static/milestone-f041c6b9b6817f77014ec3e33b57782f.png";